import { useCallback, useContext } from 'react';
import { actionRedirect } from '../../../helpers/common-helpers';
import { useNovedadesTracker } from '../helpers/use-novedades-tracker';
import { NovedadesItem } from '@esportal/portal-service';
import { IContextNovedades } from '../models/context-novedades';

interface UseNovedadesCardClickProps {
	item: NovedadesItem;
	context: React.Context<IContextNovedades>;
}

export const useNovedadesCardClick = ({ item, context }: UseNovedadesCardClickProps) => {
	const { userInteractionService } = useContext(context);

	const novedadesItemCtaSrc = item.isLayer ? item.layer.cta.src : item.card.cta.src;
	const novedadesItemId = (item.isLayer ? item.layer.title : item.card.title) ?? item.id;
	const novedadesItemCtaLabel = (item.isLayer ? item.layer.cta.label : item.card.cta.label) ?? 'Descubre más';

	const { trackCardClick } = useNovedadesTracker({ itemId: novedadesItemId.toString() });

	const regex = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;

	return useCallback(() => {
		if (novedadesItemCtaSrc) {
			trackCardClick(novedadesItemCtaLabel);

			if (userInteractionService && novedadesItemCtaSrc.includes('action:')) {
				actionRedirect(userInteractionService, novedadesItemCtaSrc);
			} else if (regex.test(novedadesItemCtaSrc)) {
				window.open(novedadesItemCtaSrc, '_blank');
			} else {
				console.log('url not valid');
			}
		}
	}, [trackCardClick, novedadesItemCtaLabel, novedadesItemCtaSrc, userInteractionService]);
};
